<svelte:head>
  <title>{data?.title || "Need"} | A Good Thing</title>
</svelte:head>

{#if data}

{#if response}
<article class="message is-success">
  <div class="message-body">
    You have responded to this need. Thank you for helping!
  </div>
</article>
{/if}
  
  <div class="columns">
    <div class="column is-narrow">
      {#if data.images?.[0]}
        <img
          alt="Offer"
          on:click={() => {
            $uiState.activeModal = {
              component: Lightbox,
              props: { images: data.images, index: 0 },
            };
          }}
          src={data.images[0]}
          style="width:240px; cursor:pointer;"
        />
      {:else}
        <img
          alt="Generic"
          src="/assets/img/box.png"
          style="height:240px;width:240px; background-color:lightgrey"
        />
      {/if}
      <div style="width:250px;">
        {#if data.images && data.images.length > 1}
          {#each data.images as url, index}
            {#if index !== 0}
              <div style="display:inline-block;margin-right: 8px;">
                <img
                  alt="Need"
                  on:click={() => {
                    $uiState.activeModal = {
                      component: Lightbox,
                      props: { images: data.images, index },
                    };
                  }}
                  src={url}
                  style="max-width:116px;"
                />
              </div>
            {/if}
          {/each}
        {/if}
      </div>
    </div>

    <div class="column">

      <h2 class="block title">{data.title}</h2>
      <h2 class="block subtitle">Needed by {data.charityDetails.name}</h2>

      {#if createdDatePhrase}
        <p class="block has-text-grey-light">Published {createdDatePhrase}</p>
      {/if}


      {#if canRespond}
      <div class="block">
        <!-- Left side -->
        <div class="level-left">
          <button class="button is-primary" on:click={() =>
            ($uiState.activeModal = {
              component: ConfirmNeedOffer,
              props: { item: { id, data }}
            })}>Respond to this need</button>
        </div>
      </div>
      {/if}

      <p class="block"><strong>What they need</strong></p>
      <p class="block" style="white-space:pre-wrap;">{data.needs}</p>

      <hr />

      <p class="block"><strong>Why they need it</strong></p>
      <p class="block" style="white-space:pre-wrap;">{data.benefits}</p>

      <hr />

      {#if data.background}
      <p class="block"><strong>About the charity</strong></p>
      <p class="block" style="white-space:pre-wrap;">{data.background}</p>

      <hr />
      {/if}


      {#if charity}
        {#if charity.type === 'EnglandAndWalesRegistered'}
          <EnglandWalesCharityFull charity={charity} />
        {:else if charity.type === 'ScotlandRegistered'}
          <ScotlandCharityFull {charity} />
        {:else if charity.type === 'NorthernIrelandRegistered'}
          <NorthernIrelandCharityFull {charity} />
        {:else if charity.type === 'CIC'}
          <CICFull {charity} />
        {:else if charity.type === 'CBS'}
          <CBSFull {charity} />
        {:else if charity.type === 'HMRCCharity'}
          <HMRCCharityFull {charity} />
        {:else}
          <UnregisteredCharityFull {charity} />
        {/if}
      {/if}

    </div>
  </div>
{/if}

<script lang="ts">
  export let id :string;
  import _ from "lodash";
  import { appState } from "../../../lib/appState";
  import { uiState } from "../../../lib/uiState";
  import Lightbox from "../../_components/Lightbox.svelte";
  
  import ConfirmNeedOffer from './_components/ConfirmNeedResponse.svelte';

  import EnglandWalesCharityFull from "../../_components/org_profiles/EnglandWalesCharityFull.svelte";
  import ScotlandCharityFull from "../../_components/org_profiles/ScotlandCharityFull.svelte";
  import NorthernIrelandCharityFull from '../../_components/org_profiles/NorthernIrelandCharityFull.svelte';
  import CICFull from '../../_components/org_profiles/CICFull.svelte';
  import CBSFull from '../../_components/org_profiles/CBSFull.svelte';
  import HMRCCharityFull from '../../_components/org_profiles/HMRCCharityFull.svelte';
  import UnregisteredCharityFull from "../../_components/org_profiles/UnregisteredCharityFull.svelte";

  import dayjs from "dayjs";
  import relativeTime from "dayjs/plugin/relativeTime";
  dayjs.extend(relativeTime);

  import geoDist from "geo-dist";

  let data : Need_v1;

  let charity : Charity_v2;

  let response : NeedResponse_v1; 

  let firebase = window.firebase;

  $: businessLocation = $appState.company!.location;

  $: createdDatePhrase = data?.created ? dayjs().to(dayjs(data.created)) : undefined;

  $: canRespond = response === undefined;

  get();
  getResponse();

  async function get() {
    firebase
      .firestore()
      .collection("needs_v1")
      .doc(id)
      .onSnapshot(async (doc) => {
        if(doc.exists) {
          data = doc.data() as Need_v1;
          getCharity(data.charity);
        }
      });
  }

  async function getCharity(charityId : CharityId) {
    firebase
      .firestore()
      .collection("charities_v2")
      .doc(charityId)
      .onSnapshot(async (doc) => {
        if(doc.exists) {
          charity = doc.data() as Charity_v2;
        }
      });
  }

  async function getResponse() {
    firebase
      .firestore()
      .collection("need_responses_v1")
      .where("need", "==", id)
      .where("company.id", "==", $appState.user?.company)
      .onSnapshot(async (result) => {
        if(!result.empty) {
          response = result.docs[0].data() as NeedResponse_v1;
        }
      });
  }

  function distance(point1 :GeoPoint, point2: GeoPoint) {
    const km = geoDist(
      point1.latitude,
      point1.longitude,
      point2.latitude,
      point2.longitude
    );
    const miles = km * 0.6213712; // miles
    if (miles < 1) {
      return "Within 1 mile";
    } else {
      return Math.round(miles) + " miles away";
    }
  }
</script>
